<!-- 数据流任务 -->
<template>
    <div class='page_content'>
        <!-- 标签页切换 -->
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" type="border-card">
            <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.tagName" :name="String(index)">
                <div class="page_content_top">
                    <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
                    <div class="page_content_top_line">
                        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                        </v-search>
                    </div>
                </div>
                <div class="page_content_center">
                    <el-table v-if="pageShowData.jurTableVo" stripe :show-summary="true" ref="mainTable" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
                        <el-table-column label="选择操作" width="80">
                            <template slot-scope="scope">
                                <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                                    <i class="el-icon-thumb"></i>
                                </el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="tableValye.isShow == 1" align="center" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                         :prop="tableValye.entityField" :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'state'">{{$common.getIsGsp(tableValye.formatterContent, scope.row.state) }}</el-tag>
                                <span v-else-if="tableValye.fieldType == 'formatter'">{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField]) }}</span>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" :smId="cmId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme },
    data() {
        //这里存放数据
        return {
            activeTab: '0', // 当前激活的标签页
            tabList: [
                { tagName: "预出库单", pathIdJurId: 94872827392 },
                { tagName: "消耗单", pathIdJurId: 7360163072 },
                { tagName: "回库单", pathIdJurId: 16382718721 },
            ],
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [
                {
                    jurName: '生成任务',
                    actionType: 0
                }
            ],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: "0",
            sField: "",
            seId: 0,
            cmId: 0,
            parentSearchData: {},
            requesUrl: this.$store.getters.getConfig.requestUrl,
            ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.cmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.cmId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 标签页切换
        handleTabClick(tab) {
            console.log('切换到:', this.tabList[tab.index]);
            // 重置选中索引
            this.selectedDataIndex = 0;
            // 重新获取权限配置和数据
            this.getPageInfo();
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (val.cmId) {
                    //销售单位
                    this.cmId = val.cmId;
                    this.getRequestData.cmName = val.cmName;
                    this.getRequestData.cmId = val.cmId;
                } else {
                    this.paramValue(val)
                }
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        async getPageInfo() {
            // 根据当前标签页获取对应的jurId
            const currentTab = this.tabList[parseInt(this.activeTab)];
            var pathId = { jurId: currentTab.pathIdJurId };
            
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
            if (responseData.status == 200) {
                this.getButtonList();
                this.pageShowData = responseData.result;
                this.formDataList = [];
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 动作集合
        async actionSet() {
            // 检查是否选中了数据
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            
            // 获取选中行的id
            const selectedRow = this.returnData.list[this.selectedDataIndex];
            let responseData;
            const tabIndex = parseInt(this.activeTab);
            let param = {}
            console.log('当前标签页索引data:', selectedRow);
            switch (tabIndex) {
                case 2: // 回库单
                    if (!selectedRow.returnId) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    param = {
                        ids: [selectedRow.returnId]
                    }
                    responseData = await this.$http.consumeAdminRetryReturnDataflow(param);
                    console.log('调用回库单接口');
                    break;
                case 1: // 消耗单
                    if (!selectedRow.cosumId) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    param = {
                        ids: [selectedRow.cosumId]
                    }
                    responseData = await this.$http.consumeAdminRetryConsumeDataflow(param);
                    break;
                case 0: // 预出库订单
                    if (!selectedRow.pwomId) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    param = {
                        ids: [selectedRow.pwomId]
                    }
                    responseData = await this.$http.pwoapplyRetryDataflow(param);
                    break;
                default:
                    break;
            }
            
            if (responseData && responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                // 刷新列表
                this.getDataList();
            } else if (responseData) {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            console.log('搜索数据:', this.getRequestData)
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            // TODO: 根据不同的标签页调用不同的接口
            // 回库单: this.$http.backHisQuery(this.getRequestData)
            // 消耗单单: this.$http.consumeAdminqueryHis(this.getRequestData)
            // 预出库订单单: this.$http.pwoapplyqueryHis(this.getRequestData)
            
            let responseData;
            const tabIndex = parseInt(this.activeTab);
            
            switch (tabIndex) {
                case 2: // 回库单
                    responseData = await this.$http.consumeAdminQueryReturnDataflowFailed(this.getRequestData);
                    console.log('调用回库单接口');
                    break;
                case 1: // 消耗单
                    responseData = await this.$http.consumeAdminQueryConsumeDataflowFailed(this.getRequestData);
                    break;
                case 0: // 预出库订单
                    responseData = await this.$http.pwoapplyQueryDataflowFailed(this.getRequestData);
                    break;
                default:
                    break;
            }
            
            if (responseData && responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result.list);
                this.returnData.total = responseData.result.total;
                this.selectedDataIndex = 0;
                this.$nextTick(() => {
                    // 安全调用 doLayout
                    if (this.$refs.mainTable && this.$refs.mainTable.doLayout) {
                        this.$refs.mainTable.doLayout();
                    }
                });
            } else if (responseData) {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取按钮权限（写死按钮）
        async getButtonList() {
            // 按钮已经写死在data中，这里可以留空或做其他处理
        },
        
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight()
        this.$nextTick(() => {
            // 安全调用 doLayout
            if (this.$refs.mainTable && this.$refs.mainTable.doLayout) {
                this.$refs.mainTable.doLayout();
            }
        });
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>
